import React, { FC } from 'react';
import styles from './index.module.less'
import {
  BellOutlined
} from '@ant-design/icons';
import { Tooltip } from 'antd';
import { getFormatTime } from "../../effects/until";

export const UnapprovedItem: FC<any> = ({
  label,
  username,
  notice,
  time,
}) => {
  
    return (
      <div className={styles['unapproved-box']}>
        <div>
          <span className={styles['unapproved-head-name-label']}>{label || '评审人'}</span>
          <span className={styles['unapproved-head-name-value']}>{username || '--'}</span>
          {notice && <Tooltip title="代办消息待发送"><BellOutlined /></Tooltip>}
        </div>
        {time && <div>{getFormatTime({ time, }) || '--'}</div>}
      </div>
    );
};
export default UnapprovedItem;
